export enum InputFields {
  unit = 'unit',
  model = 'model',
  suctionVolumetricFlow = 'suction_volumetric_flow',
  vacuum = 'vacuum',
  altitudeFromSeaLevel = 'altitude_from_sea_level',
  suctionAirTemperature = 'suction_air_temperature',
  suctionAirRelativeHumidity = 'suction_air_relative_humidity',
  temperatureAfterRecovery = 'temperature_after_recovery',
  relativeHumidityAfterRecovery = 'relative_humidity_after_recovery',
  absolutePressureAfterRecovery = 'absolute_pressure_after_recovery',
  dischargeAbsolutePressure = 'discharge_absolute_pressure ',
  atmosphericPressure = 'atmospheric_pressure',
}
